import React from "react";
import { Card, IconPanel, Stack, Subtitle, Tag, Text, TitleRow } from "./CardStack.styles";
import type { CardStackProps } from "./CardStack.types";

/** Stacked promo cards. With three the stack cycles by CSS alone; fewer stay still. */
export const CardStack: React.FC<CardStackProps> = ({ cards, soonLabel, label, className }) => {
  const shown = cards.slice(0, 3);
  const animate = shown.length === 3;
  return (
    <Stack role="group" aria-label={label} className={className}>
      {shown.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card
            key={card.id}
            type="button"
            $index={index}
            $animate={animate}
            $disabled={Boolean(card.soon)}
            aria-disabled={card.soon ? "true" : undefined}
            onClick={card.soon ? undefined : card.onSelect}
            title={[card.title, card.subtitle].filter(Boolean).join(" - ")}
          >
            <Text>
              <TitleRow>
                {card.title}
                {card.soon ? <Tag>{soonLabel}</Tag> : null}
              </TitleRow>
              <Subtitle>{card.subtitle}</Subtitle>
            </Text>
            <IconPanel aria-hidden="true" $accent={card.accent ?? "primary"}>
              <Icon size={28} />
            </IconPanel>
          </Card>
        );
      })}
    </Stack>
  );
};

export default CardStack;
